var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-height-flag" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.gridl, false),
            [
              _c("tree", {
                attrs: {
                  "parent-tree": _vm.treeData,
                  "frame-id": _vm.frame_id,
                  types: _vm.types,
                },
                on: { frameId: _vm.getFrameId },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", _vm._b({}, "el-col", _vm.gridr, false), [
            _c(
              "div",
              { staticClass: "v-height-flag" },
              [
                _vm.search.length > 0
                  ? _c("oaFromBox", {
                      attrs: {
                        search: _vm.search,
                        viewSearch: _vm.viewSearch,
                        total: _vm.total,
                        title: "物资记录",
                        btnText: "导出",
                        btnIcon: false,
                        isAddBtn: true,
                      },
                      on: {
                        addDataFn: _vm.handleExport,
                        confirmData: _vm.confirmData,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table-box mt10 v-height-flag" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tableData,
                          height: _vm.tableHeight,
                          "row-key": "id",
                          "default-expand-all": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "id",
                            label: "领取部门 / 人员",
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.frame
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.frame
                                                ? scope.row.frame.name
                                                : "--"
                                            )
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.card
                                              ? scope.row.card.name
                                              : "--"
                                          )
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage.name",
                            label: "物资名称",
                            "min-width": "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage.units",
                            label: "规格型号",
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        scope.row.storage.units
                                          ? scope.row.storage.units
                                          : "--"
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage.cate.cate_name",
                            label: "物资分类",
                            "min-width": "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage.specs",
                            label: "计量单位",
                            "min-width": "80",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "领用数量",
                            "min-width": "80",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "updated_at",
                            label: "领用时间",
                            "min-width": "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm
                                          .$moment(scope.row.updated_at)
                                          .format("yyyy-MM-DD")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-fixed" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.where.page,
              "page-sizes": [15, 20, 30],
              layout: "total, sizes,prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: false,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }